import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHistory,FaShareAlt,FaPlay,FaTelegramPlane,FaWhatsapp } from "react-icons/fa";
import { MdHome } from "react-icons/md";
import { AuthContext, getSavedReferCode, shareApp, getSavedChatContact, getSupportInfo } from '../context/AuthContext';
function Footer({ page }) {
  const { TelegramShareMessage, SupportContact } = useContext(AuthContext);
  const loggedIn = localStorage.getItem('login') && localStorage.getItem('login') !== '';
  // Chat opens the Telegram or WhatsApp set by admin in "Footer Chat" (separate from the Playground button)
  const [Support, setSupport] = useState(getSupportInfo(getSavedChatContact()));

  // Fetch the refer code once in advance so Share can open the share sheet instantly
  useEffect(() => {
    if (loggedIn && !getSavedReferCode()) {
      TelegramShareMessage();
    }
  }, [loggedIn, TelegramShareMessage]);

  useEffect(() => {
    SupportContact((contact, chat) => setSupport(getSupportInfo(chat)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShare = (e) => {
    e.preventDefault();
    shareApp(getSavedReferCode());
  };

  return (
    <>
      <div className="footer-tab">
        <Link to='/dashboard' className='footer-btn-container'>
          <MdHome />
          <p>Home</p>
        </Link>
        <Link to='/playground' className='footer-btn-container'>
          <FaPlay />
          <p>Play</p>
        </Link>
        {loggedIn ?
        <Link to='/history/all' className='footer-btn-container'>
          <FaHistory />
          <p>History</p>
        </Link>
        : '' }
        {loggedIn ?
        <Link to='#' onClick={handleShare} className='footer-btn-container'>
          <FaShareAlt/>
          <p>Share</p>
        </Link>
        : '' }
        {/* Chat opens the Telegram or WhatsApp chosen by admin, at the link admin set */}
        <a href={Support.url} target="_blank" rel="noopener noreferrer" className='footer-btn-container'>
          {Support.type === 'whatsapp' ? <FaWhatsapp /> : <FaTelegramPlane />}
          <p>Chat</p>
        </a>
      </div>
    </>
  )
}

export default Footer;
